import { Empty as AntEmpty } from 'antd';
import React from 'react';

const Empty = ({ description = 'No Data', ...rest }) => {
  return <AntEmpty image={Empty.PRESENTED_IMAGE_SIMPLE} description={description} {...rest} />;
};

export default Empty;
